import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const dataModuleActions = createDataModuleActions('UPLOAD_CARD_DOCUMENTS');
export const uploadCardDocuments = dataModuleActions.dataRequest;
export const uploadCardDocumentsSuccess = dataModuleActions.dataSuccess;
export const uploadCardDocumentsError = dataModuleActions.dataError;
export const uploadCardDocumentsReset = dataModuleActions.dataReset;
